import React, { useState, useEffect } from 'react';
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { Button, Flex, Input, Upload, Select, Spin } from 'antd';
import {
    CAvatar,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from '@coreui/react'
import { getStyle, hexToRgba } from '@coreui/utils'
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import CIcon from '@coreui/icons-react'
import axios from 'axios';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const baseURL = apiUrls.baseURL;
const formatChartValue = (value) => new Intl.NumberFormat('fa-IR').format(value);
const toPersianDigits = (value) => String(value).replace(/[0-9]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[Number(digit)]);
const financialChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    font: { family: 'Vazir, sans-serif' },
    layout: { padding: { top: 6, bottom: 0, left: 0, right: 4 } },
    interaction: { mode: 'index', intersect: false },
    plugins: {
        legend: { display: false },
        tooltip: {
            rtl: true,
            textDirection: 'rtl',
            displayColors: true,
            callbacks: {
                label: (context) => `${context.dataset.label}: ${formatChartValue(context.parsed.y)} ریال`,
            },
        },
    },
    scales: {
        x: {
            grid: { display: false },
            border: { display: false },
            ticks: {
                color: '#435d6c',
                maxRotation: 0,
                minRotation: 0,
                autoSkip: true,
                font: { family: 'Vazir, sans-serif', size: 13, weight: 600 },
                callback: function (value) {
                    return toPersianDigits(this.getLabelForValue(value));
                },
            },
        },
        y: {
            beginAtZero: true,
            border: { display: false, dash: [4, 4] },
            grid: { color: 'rgba(71, 105, 123, 0.10)', drawTicks: false },
            ticks: {
                color: '#344f5e',
                padding: 9,
                font: { family: 'Vazir, sans-serif', size: 14, weight: 700 },
                callback: (value) => formatChartValue(value),
            },
        },
    },
};

const WorkingGroupFinancialChartReport = () => {
    //const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

    const [mountaineeringData, setMountaineeringData] = useState([]);
    const [educationData, setEducationData] = useState([]);
    const [trialData, setTrialData] = useState([]);
    const [climbingData, setClimbingData] = useState([]);
    const [cavingData, setCavingData] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);

    useEffect(() => {
        dispatch({ type: 'set', isShow: true })
        fetchMountaineeringChart()
        fetchEducationChart()
        fetchClimbingChart()
        fetchCavingChart()
        fetchTrialChart()
    }, [])

    const fetchMountaineeringChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=2`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setMountaineeringData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchTrialChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=1`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setTrialData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchEducationChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=11`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setEducationData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchClimbingChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=3`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setClimbingData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchCavingChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/workinggroupcategory/GetFinancialChartReport?id=8`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setCavingData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const renderFinancialChart = (title, chartData, color) => (
        <CCol xs={12} lg={6} className="financial-chart-column" key={title}>
            <CCard className="financial-chart-card">
                <CCardHeader className="financial-chart-card-header">
                    <span className="financial-chart-accent" style={{ backgroundColor: color }} />
                    <strong>{title}</strong>
                    <span className="financial-chart-unit">ریال</span>
                </CCardHeader>
                <CCardBody className="financial-chart-card-body">
                    <div className="financial-chart-canvas">
                        <CChartBar
                            data={{
                                labels: chartData?.years || [],
                                datasets: [{
                                    label: 'درآمد باشگاه',
                                    backgroundColor: `${color}cc`,
                                    borderColor: color,
                                    borderWidth: 1,
                                    borderRadius: 7,
                                    borderSkipped: false,
                                    maxBarThickness: 42,
                                    categoryPercentage: 0.68,
                                    barPercentage: 0.82,
                                    data: chartData?.clubIncomes || [],
                                }],
                            }}
                            options={financialChartOptions}
                        />
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    );

    if (loading) {
        return <Spin size="large" />
    }
    return (
        <div className='row financial-chart-report-page'>
            <HideSidebarInMobileMode/>

            
            <div className="financial-chart-report-heading">
                <div><strong>گزارش درآمد مالی کارگروه‌ها</strong><span>مقایسهٔ درآمد باشگاه به تفکیک سال</span></div>
            </div>
            <CRow className="financial-chart-report-grid">
                {renderFinancialChart('کارگروه کوه‌پیمایی', mountaineeringData, '#1685c5')}
                {renderFinancialChart('کارگروه آموزش', educationData, '#13a58b')}
                {renderFinancialChart('کارگروه سنگ‌نوردی', climbingData, '#e0a52b')}
                {renderFinancialChart('کارگروه غارنوردی', cavingData, '#8467c8')}
                {renderFinancialChart('کارگروه آزمایشی', trialData, '#df6b84')}
            </CRow>
</div>
    )
}

export default WorkingGroupFinancialChartReport
